import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FilterOption, FilterOptions } from '../table/table.component';

@Component({
  selector: 'app-table-filter-dropdown-mobile',
  templateUrl: './table-filter-dropdown-mobile.component.html',
  styleUrls: ['./table-filter-dropdown-mobile.component.css'],
})
export class TableFilterDropdownMobileComponent<T> implements OnInit {
  @Input() filterOptions: FilterOptions<T>;

  @Output() filterClicked = new EventEmitter<FilterOption<T>>();

  showList = false;
  selectedOption: FilterOption<T>;

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      if (this.showList) {
        this.showList = false;
      }
    }
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    const { options, activeFilters } = this.filterOptions;

    this.selectedOption = options.find(({ value }) =>
      value.length === activeFilters.length &&
      value.every((val, idx) => val === activeFilters[idx])
    ) || options[0];
  }

  toggleList() {
    this.showList = !this.showList;
  }

  onClickFilter(option: FilterOption<T>) {
    this.selectedOption = option;
    this.toggleList();
    this.filterClicked.emit(option);
  }
}
